!((document, Drupal, $) => {
  'use strict';

  /**
   * Handle the main navigation bar
   */
  Drupal.behaviors.headerNavbar = {

    attach: function (context) {
      // eslint-disable-next-line max-len
      const $headerNavbarDropdown = $(once('headerNavbarDropdown', '.header-navbar .main-menu-dropdown', context));
      $headerNavbarDropdown.each(function () {
        $(this).bind('beforeshow', function () {
          $(this).find('.uk-icon-center-right svg')
            .addClass('uk-position-center-right');
        });
      });

      // eslint-disable-next-line max-len
      let $disableSwitcher = $(context).find('.header-navbar .language-dropdown .js-add-language-switcher-none').length;
      if ($disableSwitcher > 0) {
        $(context).find('.header-navbar .language-switcher').addClass('language-switcher--none');
        $(context).find('#language-switcher-mobile-container').addClass('language-switcher--none');
      }
      else {
        // eslint-disable-next-line max-len
        const $headerNavbarDropdown = $(once('headerNavbarDropdown', '.header-navbar .language-dropdown', context));
        $headerNavbarDropdown.each(function () {
          // Toggle link icon
          let $link = $(this).prev('a.uk-icon');
          if ($link.length === 0 ||
            (!$link.attr('uk-open-icon') && !$link.attr('uk-close-icon'))
          ) {
            return;
          }
          $(this).bind('show', function () {
            $link.fadeOut(50, function () {
              $link.attr('uk-icon', $link.attr('uk-close-icon'));
            });
            $link.fadeIn(150);
          });
          $(this).bind('hide', function () {
            $link.fadeOut(50, function () {
              $link.attr('uk-icon', $link.attr('uk-open-icon'));
            });
            $link.fadeIn(150);
          });
        });
      }
    }

  };

})(document, Drupal, jQuery);
